module.exports = __webpack_public_path__ + "media/images/logo-dark-65fbc1b6b2f82e6d39c73b5f7b9af4dd.png";